<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="21.875"><path d="M4.072 9.5l10.771 1.436-10.771 1.437L0 21.875h3.125L25 10.938 3.125 0H0z"/></svg>
</template>

<script>
	export default {
		name: "PaperPlane"
	}
</script>